import { render, staticRenderFns } from "./SchoolApplicationPage.vue?vue&type=template&id=ba16e196&lang=pug&"
import script from "./SchoolApplicationPage.vue?vue&type=script&lang=js&"
export * from "./SchoolApplicationPage.vue?vue&type=script&lang=js&"
import style0 from "./SchoolApplicationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports